"use client";

import { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./MobileArrow.css";

export default function MobileArrow() {
  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowArrow(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {showArrow && (
        <div className="mobile-arrow-scroll-top" onClick={scrollToTop}>
          <FaArrowUp className="mobile-arrow-icon" />
        </div>
      )}
    </>
  );
}